import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { getUser, appRedirect } from "app/NativeActions";

class RedirectToLogin extends Component {
  componentDidMount() {
    const token = window.localStorage.getItem("token");
    if (token != null) {
      this.props.getUser({
        token,
        device: this.props.device,
        redirect: true
      });
    } else {
      this.props.appRedirect({ redirect: "login" });
    }
  }

  render() {
    return <div />;
  }
}

const mapStateToProps = ({ auth }) => {
  const { token, user, init, loading } = auth;

  return {
    token,
    user,
    init,
    loading
  };
};

export default withRouter(
  connect(mapStateToProps, { getUser, appRedirect })(RedirectToLogin)
);
